module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Black.woff?14a450a3d2fd191fcefa23b273baaf14";